import type { MovementDirection } from './movement-interval';

type RectLike = {
  left: number;
  top: number;
  width: number;
  height: number;
};

/**
 * Whether the leading edge of dragRect has crossed the midpoint of dropRect.
 */
export const getMidpointImpact = ({
  dragRect,
  dropRect,
  direction,
  offsetMultiplier = 0,
}: {
  dragRect: RectLike;
  dropRect: RectLike;
  direction: MovementDirection;
  offsetMultiplier?: number;
}): boolean => {
  const dropCenterX = dropRect.left + dropRect.width / 2;
  const dropCenterY = dropRect.top + dropRect.height / 2;
  const dragLeft = dragRect.left;
  const dragTop = dragRect.top;
  const dragRight = dragRect.left + dragRect.width;
  const dragBottom = dragRect.top + dragRect.height;

  if (direction === 'down') {
    const offset = offsetMultiplier * dropRect.height;
    return dragBottom >= dropCenterY + offset;
  }
  if (direction === 'up') {
    const offset = offsetMultiplier * dropRect.height;
    return dragTop < dropCenterY - offset;
  }
  if (direction === 'left') {
    const offset = offsetMultiplier * dropRect.width;
    return dropCenterX - offset >= dragLeft;
  }

  const offset = offsetMultiplier * dropRect.width;
  return dragRight - offset >= dropCenterX;
};
